import type { Credential } from './types';

// Canonical meaning of remote claims. Demo labels must never redefine these.
export const credentialDefinitions = [
  ['brreg_stiftet_over_3aar', '1', 'brreg', 'stiftet', 10, 'Stiftet > 3 år siden', 'Founded more than 3 years ago'],
  ['brreg_arsregnskap_innen_frist', '2', 'brreg', 'arsregnskap', 10, 'Årsregnskap levert', 'Annual accounts submitted on time'],
  ['brreg_kvinneandel_over_40', '3', 'brreg', 'kvinneandel', 5, 'Kvinneandel > 40%', 'Women representation above 40%'],
  ['skatteetaten_ingen_mva', '4', 'skatteetaten', 'mva', 10, 'Ingen utestående MVA', 'No outstanding VAT'],
  ['skatteetaten_ingen_utlegg', '5', 'skatteetaten', 'utlegg', 15, 'Ingen utleggsforretninger', 'No enforcement proceedings'],
  ['skatteetaten_ingen_aga', '6', 'skatteetaten', 'arbeidsgiveravgift', 5, 'Ingen utestående arbeidsgiveravgift', 'No outstanding employer contributions'],
  ['bank_aktiv_bedriftskonto_2aar', '7', 'bank', 'bedriftskonto', 5, 'Aktiv bedriftskonto i over 2 år', 'Active business account for over 2 years'],
  ['bank_ingen_overtrekk_6mnd', '8', 'bank', 'overtrekk', 5, 'Ingen overtrekk siste 6 måneder', 'No overdrafts in the last 6 months'],
  ['bank_faktura_betalt_90', '9', 'bank', 'fakturaer', 10, 'Over 90 % av fakturaene betalt i tide', 'Over 90% of invoices paid on time'],
  ['tilsyn_ingen_dommer', 'symfoni-10', 'tilsyn', 'dommer', 10, 'Ingen dommer', 'No convictions'],
  ['tilsyn_ingen_sanksjoner_24mnd', 'symfoni-11', 'tilsyn', 'sanksjoner', 10, 'Ingen sanksjoner siste 24 måneder', 'No sanctions in the last 24 months'],
  ['tilsyn_ingen_konkurskarantene', 'symfoni-12', 'tilsyn', 'konkurskarantene', 5, 'Ingen konkurskarantene', 'No bankruptcy disqualification'],
] as const;

export function getRemoteCredentials(locale: string): Credential[] {
  return credentialDefinitions.map(([, id, source, type, points, nb, en]) => ({
    id, source, type, points,
    title: locale.toLowerCase().startsWith('en') ? en : nb,
    description: locale.toLowerCase().startsWith('en') ? en : nb,
    verified: true,
    // The catalog does not assert an issuance date; real claim metadata is not exposed by this API.
    issuedAt: new Date(0),
  }));
}
